<template>
  <v-card>
    <v-card-title class="v-toolbar__title black--text font-weight-medium pt-8">
      {{ $t('Widgets.installation') }}
      <v-spacer />
      <v-btn icon @click="$emit('close-installation-modal')">
        <v-icon class="gray--text">mdi-close </v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <div class="black--text mt-4">
        {{ $t('Widgets.selectAnInstallation') }}
      </div>
      <installation-dialog-element
        :title="$t('Widgets.requestOpinewInstallation')"
        :subtitle="$t('Widgets.contactOurSupportEngineers')"
        :button-label="$t('Widgets.liveChat')"
        use-case="request_installation"
        class="mt-4"
        image-url="https://cdn.opinew.com/dashboard/images/livechat_icon.svg"
        @close-dialog="$emit('close-installation-modal')"
      />
      <installation-dialog-element
        :title="$t('Widgets.installViaEditor')"
        :subtitle="$t('Widgets.installOpinewSnippets')"
        :button-label="$t('Widgets.editCode')"
        :installation-instructions="installationInstructions"
        use-case="via_editor"
        image-url="https://cdn.opinew.com/dashboard/images/code_icon.svg"
        class="mt-4"
        @close-dialog="$emit('close-installation-modal')"
      />
      <installation-dialog-element
        :title="$t('Widgets.emailInstructionsTo')"
        :subtitle="$t('Widgets.sendInstallationInstructions')"
        :placeholder="$t('Widgets.addEmail')"
        :button-label="$t('Widgets.send')"
        use-case="send_email"
        image-url="https://cdn.opinew.com/dashboard/images/email_icon.svg"
        class="mt-4"
        :instructions-url="instructionsUrl"
        :widget-name="widgetName"
      />
      <installation-dialog-element
        :title="$t('Widgets.installViaBuilder')"
        :subtitle="$t('Widgets.ifYoureUsing')"
        :button-label="$t('Widgets.goToInstructions')"
        use-case="via_builder"
        image-url="https://cdn.opinew.com/dashboard/images/pagebuilder_icon.svg"
        class="mt-4"
      />

      <v-row no-gutters class="mt-8">
        <v-col cols="12">
          <div class="d-flex justify-end">
            <v-btn color="black_lighten2" outlined @click="$emit('close-installation-modal')">
              <span class="black--text"> {{ $t('Widgets.cancel') }} </span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import InstallationDialogElement from '@/components/widgets/InstallationDialogElement';
export default {
  name: 'InstallationModal',
  components: {
    InstallationDialogElement,
  },
  props: {
    widgetName: {
      type: String,
      default: '',
    },
    instructionsUrl: {
      type: String,
      default: '',
    },
    installationInstructions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.stepsBullets {
  border-radius: 100px;
  height: 16px;
  width: 17px;
  font-size: 8px;
  text-align: center;
}

.stepDone {
  background: #2b64c9;
  color: white;
}

.stepPending {
  background: #bfbfbf;
  color: #707070;
}

.profileName {
  font-size: 16px;
  font-weight: bold;
}

.fbText {
  font-size: 16px;
}

.information {
  display: flex;
  flex-direction: column;
}
.well {
  padding: 20px 20px;
  border-radius: 20px;
}
.list-item:first-child {
  margin: 0;
}
.list-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.button {
  margin: auto;
}
</style>
